<script setup lang="ts">
import type { PropType } from "vue";
import type { PasswordProps } from "primevue/password";

const value = defineModel<string>();

defineProps({
  name: {
    type: String as PropType<PasswordProps["name"]>,
    default: "",
  },
  error: {
    type: String,
    default: "",
  },
  size: {
    type: String as PropType<PasswordProps["size"]>,
    default: "small",
  },
  placeholder: {
    type: String as PropType<PasswordProps["placeholder"]>,
    default: "",
  },
  fluid: {
    type: Boolean as PropType<PasswordProps["fluid"]>,
    default: false,
  },
});
</script>

<template>
  <div>
    <Password
      v-model="value"
      :invalid="!!error"
      :feedback="false"
      toggle-mask
      :name="name"
      :placeholder="placeholder"
      :size="size"
      :pt-options="{ mergeProps: true }"
      :fluid="fluid"
      help
    />
    <div v-if="error" class="mt-2 text-sm text-[#888888]">
      <span class="text-red-500">*</span> {{ error }}
    </div>
  </div>
</template>

<style scoped></style>
